import angular from 'angular'

// components
import collapseToggle from './component/collapseToggle.js'

export default angular
  .module('portalApp.collapseToggle', [])
  .component('collapseToggle', collapseToggle)
  .name
